import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../../utils/errorUtils";
import logger from "../../../utils/logger";

const initialState = {
	clientTokenResponse: null,
	authorizationTokenResponse: null,
	klarnaInstance: null
};

const klarnaReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case 'UPDATE_CLIENT_TOKEN_RESPONSE':
			return {
				...state,
				clientTokenResponse: payload
			};
		case 'UPDATE_AUTHORIZATION_TOKEN_RESPONSE':
			return {
				...state,
				authorizationTokenResponse: payload
			};
		case 'UPDATE_KLARNA':
			return {
				...state,
				klarnaInstance: payload
			};
		case 'CLEAR_KLARNA':
			return {
				...state,
				authorizationTokenResponse: null,
				clientTokenResponse: null
			};
		default:
			return state;
	}
};

export const setClientTokenResponse = (clientTokenResponse) => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'UPDATE_CLIENT_TOKEN_RESPONSE', payload: clientTokenResponse });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const setAuthorizationTokenResponse = (authorizationTokenResponse) => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'UPDATE_AUTHORIZATION_TOKEN_RESPONSE', payload: authorizationTokenResponse });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const setKlarnaInstance = (klarnaInstance) => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'UPDATE_KLARNA', payload: klarnaInstance });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const resetKlarna = () => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'CLEAR_KLARNA', payload: null });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const useKlarna = () => {
	const dispatch = useDispatch();

	return {
		KlarnaState: useSelector((appState) => appState.klarnaState),

		clientTokenResponse: useSelector((appState) => appState.klarnaState.clientTokenResponse),
		setClientTokenResponse: (clientTokenResponse) => dispatch(setClientTokenResponse(clientTokenResponse)),
		authorizationTokenResponse: useSelector((appState) => appState.klarnaState.authorizationTokenResponse),
		setAuthorizationTokenResponse: (authorizationTokenResponse) => dispatch(setAuthorizationTokenResponse(authorizationTokenResponse)),
		klarnaInstance: useSelector((appState) => appState.klarnaState.klarnaInstance),
		setKlarnaInstance: (klarnaConnection) => dispatch(setKlarnaInstance(klarnaConnection)),
		resetKlarna: () => dispatch(resetKlarna())
	};
};

export default klarnaReducer;